import { computed, type ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

/**
 * 组合式函数：通过路由 meta 控制版本标签的可见性
 * @param baseVisibility - 基础可见性（来自版本控制逻辑）
 * @returns 最终的可见性（综合基础逻辑和路由 meta 配置）
 */
export function useEditionVisibilityWithRouteMeta(baseVisibility: ComputedRef<boolean>) {
  const route = useRoute();

  // 在 IP 模块中隐藏版本标签（通过路由 meta.isIpModule 标识）
  const isEditionVisible = computed(() => {
    if (route.meta?.isIpModule === true) {
      return false;
    }
    return baseVisibility.value;
  });

  return {
    isEditionVisible,
  };
}
